// src/constants/tags.js
export const TAG_GROUPS = {
  Intent: [
    'Anger Release',
    'Anxiety Relief',
    'Beauty & Confidence',
    'Boundary Setting',
    'Career Success',
    'Clarity',
    'Confidence Building',
    'Emotional Cleansing',
    'Energy Protection',
    'Guilt Release',
    'Healing & Wellness',
    'Letting Go',
    'Motivation',
    'Overwhelm Relief',
    'Self-Love',
    'Self-Permission',
    'Stress Release',
  ],
  Situation: [
    'After Conflict',
    'After Difficult Conversation',
    'After Work',
    'Before Bed',
    'Before Important Event',
    'Before Interaction',
    'Daily Practice',
    'Emergency Use',
    'End of Day',
    'Morning Ritual',
    'Weekend Practice',
    'When Overwhelmed',
    'When Stuck',
  ],
  Supplies: [
    'Bath/Water Access',
    'Breath & Visualization Only',
    'Candles Required',
    'Household Items',
    'Kitchen Items Only',
    'No Supplies Needed',
    'Outdoor/Nature Access',
    'Paper & Pen',
  ],
};

export const ALL_TAGS = Object.values(TAG_GROUPS).flat();
